export const EMAILS = {
  SUPPORT: "strokovnjaki@bomind.si",
};
